import React, { useState, useRef } from 'react';
import ScrollMenu from './ScrollMenu';
import DesktopMenuItems from './DesktopMenuItems';
import { CardSkeletonLoader } from '@components/common/skeletonLoader';
import cn from 'classnames';
import styles from './orders.module.scss';
import Loader from '@components/common/Loader/newLoaderModal';
import Cart from '@components/Cart';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import Modal from '@components/common/Modal';
import { Formik, Form } from 'formik';
import KeyboardInput from '@components/common/formElements/KeyboardInput/keyboardInput';
import KioskScrollMenu from './KioskScrollMenu';
import { sort } from '@utility/helperFunction';
import { flowType } from '@utility/userInfo';
import TableTopMenuItems from './TableTopMenuItems';
import TableTopCart from './TableTopCart';
import { isEmpty } from 'lodash';
import SendOrderMode from '@components/checksCommon/sendOrderMode';
import KioskCart from '@containers/KioskCart';
import Menus from './menus';
import { getObjectValue } from '@utility/utills';
import MultipleSelectedCart from '@containers/MultipleSelectedCart';
import OpenPopUp from './openPopup';

const menuItemSkeleton = [
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' },
  { className: 'skeletonMenuItem' }
];

const Orders = (props) => {
  const {
    handleRoute,
    submitSeatNumber, validateSeatNumber,
    selectedSeat,
    clearId,
    setIsVoidOpen,
    isVoidOpen,
    handlePayRoute,
    addChecksToServer
  } = props;
  const [isSendOrderMode, setIsSendOrderMode] = useState(false);
  const [footerHeight, setFooterHeight] = useState(0);
  const [deletAll, setDeleteAll] = useState(false);
  const [printState, setPrintState] = useState(false);
  const [sendAll, setSendAll] = useState(false);
  const [singleDelete, setSingleDelete] = useState(false);
  const [singleItem, setSingleItem] = useState({});
  const [moveSingle, setMoveSingle] = useState({});
  const [singleMove, setSingleMove] = useState(false);
  const [sendSelected, setSendSelected] = useState(false);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [moveType, setMoveType] = useState('');
  const [repeatData, setRepeatData] = useState();
  const [isRepeatModalOpen, setIsRepeatModalOpen] = useState(false);
  const [repeatType, setRepeatType] = useState('');
  const [moveData, setMoveData] = useState();
  const [openPriceModal, setOpenPriceModal] = useState({ modal: false, val: {}, edit: false });
  const [kioskModal, setKioskModal] = useState({
    isRestart: false,
    isCart: false,
  });
  const [xDown, setXDown] = useState(null);
  const [yDown, setYDown] = useState(null);
  const contentRef = useRef(null);
  const [orderModeData, setOrderModeData] = useState({});
  const isKiosk = flowType() === 'kiosk';
  const isServerApp = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';
  const [isConfirmationPopUp, setIsConfirmationPopUp] = useState({ isOpen: false, type: '', data: '' });
  const isWalkUp = getObjectValue(() => props.seat && (props.seat.sourceType === 7), false);
  const isDefaultMode = getObjectValue(() => (!isWalkUp && (!props.deviceInfo.deviceGroup || [0].includes(props.deviceInfo.deviceGroup.startMode))), false);
  const isCounter = getObjectValue(() => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isDriveThru = getObjectValue(() => isServerApp && [3].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isOrderPayMode = getObjectValue(() => isTableTop && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isContinuousScroll = getObjectValue(() => props.menusList[props.menuIndex].displayStyle.continuousScroll, false);
  const [isDiscountPopUp, setIsDiscountPopup] = useState(false);
  const [selected, setSelected] = useState('');
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const showDiscountOnOrders = (props.seat?.discountAmount <= 0) && props.discounts && props.auth.nonIntegratedPos && props.seat?.totalAmount?.toFixed(2) > 0;

  const handleFooter = (data) => {
    setFooterHeight(data);
  };

  const onModifyItem = (data, type) => {
    setIsRepeatModalOpen(false);
    if (data.openPrice) {
      const reqData = {
        ...openPriceModal, modal: true, val: data, edit: true
      };
      setOpenPriceModal(reqData);
    } else {
      props.onModifyItem(data, type);
    }
  };
  const move = (data, type) => {
    setMoveType(type);
    setMoveData(data);
    props.move(data);
  };

  const getTouches = (evt) => {
    return evt.touches || evt.originalEvent.touches;
  };

  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    setXDown(firstTouch.clientX);
    setYDown(firstTouch.clientY);
  };

  const handleTouchMove = (evt) => {
    if (!xDown || !yDown) return;

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        // left swipe
        props.handleSwipeCart('left');
      } else {
        // right swipe
        props.handleSwipeCart('right');
      }
    } else {
      if (yDiff > 0) {
        // up swipe
      } else {
        // down swipe
      }
    }

    setXDown(null);
    setYDown(null);
  };

  const onRemoveItemFromCart = (internalId, type) => {
    if (type === 'deleteSelect') {
      setDeleteSelected(true);
    } else {
      setSingleDelete(true);
    }
    setSingleItem(internalId);
  };

  const changeItemQuantity = (quantity, internalId) => {
    if (quantity > 0) {
      const dataToSend = {
        quantity,
        internalId
      };
      props.pushItemQuantityToCart(dataToSend);
    } else {
      onRemoveItemFromCart(internalId);
    }
  };

  const [moveArray, setMoveArray] = useState([]);

  const setSelectedToMove = (seat) => {
    if (moveArray.includes(-1)) {
      setMoveArray([seat]);
    } else if (moveArray.includes(seat)) {
      setMoveArray(moveArray.filter((e) => e !== seat));
    } else if (!moveArray.includes(-1) && !moveArray.includes(seat)) {
      setMoveArray(moveArray.concat(seat));
    }
  };

  const moveClick = (data, array, type) => {
    props.moveClick(data, array, type);
  };

  const deleteAll = (type) => {
    if (type === 'delete') {
      setDeleteAll(true);
    } else {
      setSendAll(true);
    }
  };

  const clearMoveArray = () => {
    setMoveArray([-1]);
  };

  const setOpenMovePopUp = () => {
    setMoveArray([]);
    props.setOpenMovePopUp();
  };

  const sendSingle = (data, type) => {
    if (type === 'sendSelect') {
      setSendSelected(true);
    } else {
      setSingleMove(true);
    }
    setMoveSingle(data);
  };

  const printPopUp = () => {
    props.printPopUp();
    setMoveArray(moveArray.concat(-1));
    setPrintState(true);
  };

  const setDeleteAllPopUp = () => {
    setDeleteAll(false);
    setSendAll(false);
    setSingleDelete(false);
    setSingleMove(false);
    setSendSelected(false);
    setDeleteSelected(false);
    setIsConfirmationPopUp({ isOpen: false });
  };

  const checkItemPresent = (data, type) => {
    let itemPresent = true;
    if (type === 'sent') {
      itemPresent = data.every((d) => props?.seat?.orders?.[0]?.items?.some((item) => item.checkItemId === d.id));
    }
    return itemPresent;
  };

  const getSubTotal = () => {
    let subTotal = 0;
    props.cart.forEach((item) => {
      if (!item.refill) subTotal += (item.price * item.quantity);
    });
    return `${LABEL().CURRENCY_SYMBOL}${subTotal.toFixed(2)}`;
  };

  const repeat = (type, data) => {
    setRepeatType(type);
    setRepeatData(data);
    props.handleRepeatData(data, type);
  };

  const handleRepeat = (data, type) => {
    const isAddToCart = checkItemPresent(data, type);
    if (isCounter || isOrderPayMode || isWalkUp || isDriveThru || isCallCenter) {
      setIsConfirmationPopUp({ isOpen: true, type: 'unsentRepeat', data });
    } else if ((data.length === 1) && (type === 'unsent' || type === 'sent')) {
      const val = props?.seat?.orders?.[0]?.items?.find((e) => e.checkItemId === data[0].id);
      const requiredData = type === 'sent' ? ((val && JSON.parse(JSON.parse(val.orderJson).modifierJson)) || {}) : {};
      const reqData = {
        ...openPriceModal, modal: true, val: { ...data[0], openPrice: (requiredData?.openPrice) || data[0].openPrice }, type, edit: false
      };
      if (reqData?.val?.openPrice) {
        setOpenPriceModal(reqData);
      } else if (isAddToCart) {
        repeat(type, data);
      }
    } else if (isAddToCart) {
      repeat(type, data);
    }
  };

  const goToCart = () => {
    setKioskModal({
      isCart: true
    });
  };

  const validatePrice = (val) => {
    const error = {};
    if (isEmpty(val.price)) {
      error.price = 'Enter Price';
    }
    return error;
  };

  const submitPrice = (newPrice) => {
    const isAddToCart = checkItemPresent([openPriceModal.val], openPriceModal.type);
    setOpenPriceModal({ ...openPriceModal, val: { ...openPriceModal.val, price: newPrice.price }, modal: false });
    if ((openPriceModal.type === 'unsent' || openPriceModal.type === 'sent') && isAddToCart && !openPriceModal.edit) {
      setRepeatType(openPriceModal.type);
      setRepeatData([{ ...openPriceModal, val: { ...openPriceModal.val, price: newPrice.price } }.val]);
      setIsRepeatModalOpen(!isRepeatModalOpen);
    } else {
      const dataToSend = { ...openPriceModal, val: { ...openPriceModal.val, price: newPrice.price } };
      props.openPriceEdit(dataToSend.val);
      setOpenPriceModal({ ...openPriceModal, modal: false });
    }
  };

  const handleLongPress = (data, type) => {
    setIsSendOrderMode(true);
    setOrderModeData({ type, data });
  };

  const closeSendOrderMode = (type) => {
    if (type) {
      switch (orderModeData.type) {
        case 'sendSelect':
        case 'sendSingle': props.sendSingle(orderModeData.data, type); break;
        case 'sendAll': props.sendAllItems(type); break;
        default:
          break;
      }
    }
    setIsSendOrderMode(false);
  };

  let subTotalAmount = 0;
  if (getObjectValue(() => props?.seat?.orders?.[0]?.items, false)) {
    props.seat.orders[0].items.forEach((e) => {
      subTotalAmount += JSON.parse(e.orderJson).price;
    });
  }

  const handleSelection = (item) => {
    if (item.open && (item.discountType === 1 || item.discountType === 2)) {
      setIsOpenPopUp(true);
    }
    setSelected(`${item.id}`);
  };

  const validate = (data) => {
    let errorMessage = {};
    return new Promise((resolve, reject) => {
      if (!data.discount) {
        errorMessage = { ...errorMessage, message: 'Discount cannot be empty' };
        reject(errorMessage);
      } else if (data.discount && props.discounts.find((e) => e.id === Number(selected)).discountType === 1 && (Number(data.discount) === 0 || Number(props.seat.subTotalAmount) < Number(data.discount))) {
        errorMessage = { ...errorMessage, message: 'Discount should be more than zero and not exceed sub total' };
        reject(errorMessage);
      } else if (data.discount && props.discounts.find((e) => e.id === Number(selected)).discountType === 2 && (Number(data.discount) === 0 || Number(data.discount) > 100)) {
        errorMessage = { ...errorMessage, message: 'Discount should be more than zero and not exceed 100 %' };
        reject(errorMessage);
      } else {
        resolve();
      }
    });
  };

  const handleApplyDiscount = (data) => {
    setIsDiscountPopup(false);
    const cb = () => {
      const discount = props.discounts.find((e) => e.id === Number(selected));
      const seatIds = props.seat?.seats.filter((d) => d.open);
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: props.userInfo.id,
        checkHeaderId: props.seat.id,
        employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null), 
        discounts: [
          {
            quantity: 1,
            discountId: discount.id,
            discountName: discount.name,
            value: data?.discount,
            pending: true,
            seatIds: [
              seatIds[0].id
            ],
            internalId: new Date().getTime(),
            modifierData: [],
            modifierJson: null
          }
        ],
        orderJson: 'ui-populated-data',
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      props.applyDiscountForNonIntegrated(dataToSend);
    };
    props.addInProcessItemsToCart(cb);
  };

  return (
    <>
      {(props.loading || props.menuLoading) && <Loader />}
      <div className={cn({ 'h-100': isKiosk }, { 'h-90': isServerApp }, { 'h-92': isTableTop }, 'row p-0 m-0 rowReverse')}>
        <div className={cn({ 'row h-15 m-0 align-items-center col-12 col-md-12 col-lg-12 overflowY': isKiosk }, { 'h-100 col-md-2 col-lg-2': (isServerApp) }, 'col-12 p-1', { 'd-none': isTableTop })}>
          {isKiosk && (
            <div className="h-100 col-12 row justify-content-center p-0 m-0">
              {/* <div role="presentation" onClick={(e) => handleClickLeft(e)} className="col-1 position-fixed fs-40 text-left text-primary od-text-primary pl-0" style={{ top: 0, left: 0 }}>
                <i className="fas fa-chevron-left" />
              </div> */}
              <div ref={contentRef} className="h-100 py-0 col-12 row">
                <KioskScrollMenu {...props} isContinuousScroll={isContinuousScroll} />
              </div>
              {/* <div role="presentation" onClick={(e) => handleClickRight(e)} className="col-1 position-fixed text-right text-primary od-text-primary pr-0 fs-40" style={{ top: 0, right: 0 }}>
                <i className="fas fa-chevron-right" />
              </div> */}
            </div>
          )}
          {(isServerApp || isTableTop) && (
          <div className={cn('col-12 col-md-12 px-0 h-100')}>
            <ScrollMenu handleFooter={handleFooter} {...props} innerMenu />
          </div>
          )}
        </div>
        {isKiosk && (
          <div className="h-5 col-12 d-flex align-items-center border-top border-bottom border-color-secondary text-primary od-text-primary">
            <span className="fw-700 fs-14 col-6 text-left" aria-hidden={props.cart.length === 0} role="presentation" onClick={() => { return props.cart.length > 0 && goToCart(); }}>{LABEL().VIEW_MY_ORDER}</span>
            {/* <span className="fw-700 fs-20 col-2 text-center" role="presentation" onClick={() => showRestartPop()}><i className="fa fa-times" aria-hidden="true" /></span> */}
            <span className="fw-700 fs-14 mx-2 col-6 text-right">{getSubTotal()}</span>
          </div>
        )}
        <div
          className={cn(
            { 'h-70 overflowY col-lg-12 col-md-12': isKiosk },
            { 'h-100 col-lg-7 col-md-7': isServerApp },
            { 'h-100 col-lg-9 col-md-9 col-9 px-0': isTableTop },
            'col-12 align-items-center rounded float-left px-0'
          )}
        >
          {isKiosk && (
            <div className="col-12 col-md-12 h-100 px-0">
              {(!props.menuLoading) ? <TableTopMenuItems {...props} isKiosk={isKiosk} isContinuousScroll={isContinuousScroll} /> : <CardSkeletonLoader className={styles.orderSkeleton} contentList={menuItemSkeleton} />}
            </div>
          )}
          {isTableTop && (
            <div className="col-12 col-md-12 row mx-0 h-100 px-0">
              <div className="col-2 p-0 h-100"><Menus {...props} isContinuousScroll={isContinuousScroll} /></div>
              <div className="col-10 p-0 h-100">{!props.menuLoading ? <TableTopMenuItems {...props} isKiosk={isKiosk} isContinuousScroll={isContinuousScroll} /> : <CardSkeletonLoader className={styles.orderSkeleton} contentList={menuItemSkeleton} />}</div>
            </div>
          )}
          {isServerApp && (
            <div className={cn('col-md-12 p-0 h-92 fs-12 overflowY', { 'h-100': isServerApp && (isCounter || isDriveThru || isCallCenter) })}>
              {(!props.menuLoading) ? <DesktopMenuItems footerHeight={footerHeight} {...props} /> : <CardSkeletonLoader className={styles.orderSkeleton} contentList={menuItemSkeleton} />}
            </div>
          )}
          {isServerApp && (!isCounter || !isDriveThru || !isCallCenter) && (
            <div className={cn('row mx-0 col-12 col-md-12 p-0 justify-content-center align-items-center h-8 py-1')}>
              {isDefaultMode && <button type="button" disabled={props.cart.length > 0} onClick={() => printPopUp()} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')}>{LABEL().PRINT}</button>}
              {isDefaultMode && <button type="button" onClick={() => handleRoute('stage')} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')} disabled={(Number(props?.seat?.unpaidAmount) === 0) || (props?.seat?.tickets?.filter((e) => e.ticketStatusId === 1 && e.ticketSplitTypeId === 3).length > 0) || (props?.deviceInfo?.deviceGroup?.serverAppSettings?.disablePayment)}>{LABEL().STAGE}</button>}
              {(isDefaultMode || isCounter || isWalkUp || isDriveThru || isCallCenter) && <button type="button" onClick={() => handleRoute((isCounter || isDriveThru || isWalkUp || isCallCenter) ? 'speedPay' : 'pay')} disabled={isDefaultMode && ((props?.deviceInfo?.deviceGroup?.serverAppSettings?.disablePayment) || (Number(props?.seat?.unpaidAmount) === 0))} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')}>{LABEL().PAY}</button>}
            </div>
          )}
        </div>
        {isKiosk && (
        <div className={cn('row m-0 h-10 col-12 col-md-12 p-0 px-4 justify-content-center align-items-end')}>
          <button className={cn('btn btn100 btn-primary btn-ripple od-btn-primary border-0 fw-700 w-70')} disabled={props.cart.length === 0} type="button" onClick={() => props.handleKioskCheckout()}>
            <div className="fs-30">{LABEL().CHECKOUT} ({props.cart.filter((e) => !e.isLinked).length})</div>
          </button>
        </div>
        )}
        {(isServerApp || isTableTop || isSendOrderMode) && (!isCounter || !isDriveThru || !isCallCenter) && (
          <div className="col-12 col-lg-3 col-md-3 px-1 row mx-0 h-100 py-1">
            {isServerApp && (
            <>
              {isDefaultMode && (
                <div
                  className={cn('row mx-0 w-100 h-5')}
                  onTouchMove={(e) => handleTouchMove(e)}
                  onTouchStart={(e) => handleTouchStart(e)}
                  role="alert"
                >
                  <div
                    className="col-1 col-md-1 p-0 od-text-primary text-primary text-left"
                    role="presentation"
                    onClick={() => props.handleSwipeCart('right')}
                  >
                    <i className="fa fa-chevron-left fs-14" aria-hidden="true" />
                  </div>
                  <div className={cn('col-10 col-md-10 row mx-0 fw-600 px-1')}>
                    <div className={cn('od-text-primary fs-12 text-primary', selectedSeat !== -1 ? 'col-5 col-md-5 p-0' : 'col-12 col-md-12 text-center p-0')}>{selectedSeat !== -1 ? `${LABEL().SEAT} ${selectedSeat}` : LABEL().TABLE}</div>
                    {selectedSeat !== -1 && (
                      <div className="col-7 col-md-7 px-1 row justify-content-center mx-0">
                        {props.currentSwipedSeats.map((seat) => {
                          return (
                            <div key={seat.id} className={cn('px-1', styles.selectedSwipe, Number(selectedSeat) === seat.number ? 'od-text-primary text-primary' : 'od-text-secondary text-secondary')}>
                              <i className="fas fa-circle fs-10" aria-hidden="true" />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  <div
                    className="col-1 col-md-1 p-0 od-text-primary text-primary text-right"
                    role="presentation"
                    onClick={() => props.handleSwipeCart('left')}
                  >
                    <i className="fa fa-chevron-right fs-14" aria-hidden="true" />
                  </div>
                </div>
              )}
              <div
                className={cn('col-12 p-0 pb-2', isDefaultMode ? 'h-90' : 'h-95')}
              >
                {!isSendOrderMode && (
                  <Cart
                    cart={props.cart || []}
                    position={props.position}
                    sendSingle={sendSingle}
                    handleLongPress={handleLongPress}
                    isRefill={props.isRefill}
                    changeItemQuantity={changeItemQuantity}
                    onRemoveItemFromCart={onRemoveItemFromCart}
                    onModifyItem={onModifyItem}
                    move={move}
                    deleteAll={deleteAll}
                    seat={props.seat}
                    handleRepeat={handleRepeat}
                    handleMangerAuthentication={props.handleMangerAuthentication}
                    setVoidItemData={props.setVoidItemData}
                    auth={props.auth}
                    highlightedCartItems={props.highlightedCartItems}
                    deviceInfo={props.deviceInfo}
                    checkItemPresent={checkItemPresent}
                  />
                )}
                {isSendOrderMode && (
                  <SendOrderMode
                    isOpen={isSendOrderMode}
                    onClose={closeSendOrderMode}
                  />
                )}
              </div>
              {isDefaultMode ? (
                <div
                  className={cn('col-12 h-5 px-1 p-0 align-items-center row mx-0 border od-container-card-border border-color-primary rounded justify-content-around text-primary od-text-primary')}
                >
                  <div className={cn('p-0 fs-14', showDiscountOnOrders ? 'col-5' : 'col-6')}>{LABEL().TOTAL}: {LABEL().CURRENCY_SYMBOL}{Number(props?.seat?.totalAmount).toFixed(2)}</div>
                  {showDiscountOnOrders && (
                  <div className="col-2 m-0 fs-14 p-0">
                    <button
                      type="button"
                      className={cn('w-100 fs-14 btn-primary btn-ripple rounded btn15 btn od-btn-primary fw-600')}
                      onClick={() => { setIsDiscountPopup(true); setSelected(''); }}
                    >
                      % / {LABEL().CURRENCY_SYMBOL}
                    </button>
                  </div>
                  )}
                  <div className={cn('p-0 fs-14 text-right', showDiscountOnOrders ? 'col-5' : 'col-6')}>{LABEL().DUE}: {LABEL().CURRENCY_SYMBOL}{Number(props?.seat?.unpaidAmount).toFixed(2)}</div>
                </div>
              ) : (
                <div
                  className={cn('col-12 h-5 p-1 row mx-0 border od-container-card-border border-color-primary rounded justify-content-around text-primary od-text-primary')}
                >
                  <div className="text-center fs-14">{LABEL().SUB_TOTAL}: {LABEL().CURRENCY_SYMBOL}{Number(subTotalAmount).toFixed(2)}</div>
                </div>
              )}
            </>
            )}
            {isTableTop && !props.menuLoading && (
              <div
                className={cn('col-12 p-0 h-100')}
              >
                {/* <TableTopCart
                  cart={props.cart || []}
                  position={props.position}
                  sendSingle={sendSingle}
                  isRefill={props.isRefill}
                  changeItemQuantity={changeItemQuantity}
                  onRemoveItemFromCart={onRemoveItemFromCart}
                  onModifyItem={onModifyItem}
                  move={move}
                  deleteAll={deleteAll}
                  seat={props.seat}
                  deleteItem={props.deleteItem}
                  handleRepeat={handleRepeat}
                  auth={props.auth}
                  checkOut={props.checkOut}
                  highlightedCartItems={props.highlightedCartItems}
                  deviceInfo={props.deviceInfo}
                  handleRoute={() => handleRoute('speedPay')}
                /> */}
                <MultipleSelectedCart
                  handleRoute={() => handleRoute('speedPay')}
                  deleteItem={props.deleteItem}
                  checkOut={props.checkOut}
                  addChecksToServer={addChecksToServer}
                />
              </div>
            )}
          </div>
        )}
        {(isCounter || isDriveThru || isCallCenter) && (
        <div className="col-12 col-lg-3 col-md-3 px-1 row mx-0 h-100 py-1">
          <div className="col-12 p-0 h-5 text-center text-primary od-text-primary">#{props.seat?.number}</div>
          <div className="h-85 w-100">
            <TableTopCart {...props} />
          </div>
          <div className={cn('row mx-0 col-12 col-md-12 p-0 justify-content-center align-items-end h-10 py-1')}>
            {props.isFinalise ? (
              <button type="button" onClick={() => props.finaliseOrder()} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')} disabled={props.cart.length === 0}>{LABEL().FINALIZE_ORDER}</button>
            ) : (
              <>
                {props.seat?.totalAmount > 0 ? (
                  <>
                    <button type="button" onClick={() => handlePayRoute('cash')} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')} disabled={!props.userInfo.supportsCash}>{LABEL().CASH}</button>
                    <button type="button" onClick={() => handlePayRoute('creditCard')} disabled={props.auth.serverAppFeatures.disablePayment} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')}>{LABEL().CREDIT_CARD}</button>
                  </>
                ) : (
                  <button type="button" onClick={() => handlePayRoute('sendOrder')} className={cn('mx-1 col h-100 btn20 fs-18 rounded btn btn-primary btn-ripple od-btn-primary color-white')}>{LABEL().SEND_ORDER}</button>
                )}
              </>
            )}
          </div>
        </div>
        )}
      </div>
      <Modal
        isOpen={props.isModalOpen}
        loading={props.loading}
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}> */}
          <div className="px-2 text-right">
            <i
              className="fa fa-times fs-18"
              aria-hidden="true"
              role="presentation"
              onClick={() => { props.closeModal(); }}
            />
          </div>
          {/* </div> */}
          <Formik
            initialValues={{ seatNumber: '' }}
            onSubmit={submitSeatNumber}
            validate={validateSeatNumber}
          >
            {() => {
              return (
                <Form>
                  {props.isModalOpen && (
                    <KeyboardInput
                      name="seatNumber"
                      type="number"
                      erase
                      placeholder={CUSTOM_MESSAGES().ENTER_SEAT_NUMBER}
                      isOpen={props.isModalOpen}
                      customClass="mt-2"
                    />
                  )}
                  <button
                    className={cn('w-100 mt-2 btn btn-primary btn-ripple od-btn-primary')}
                    type="submit"
                    style={{ height: '10vh' }}
                  >
                    <div className="fs-18">{LABEL().OCCUPY_SEAT}</div>
                  </button>
                </Form>
              );
            }}
          </Formik>
          {/* <SeatNumberKeyboard name="seatNumber" handleSeatNumberSubmit={submitSeatNumber} check={props.seat} /> */}
        </div>
      </Modal>
      <Modal
        isOpen={props.isPrintOpen}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div>
            <div className="text-left">Printer IP Address :{props.printData.printerIpAddress}</div><br />
            <div className="text-left">Printer Name: {props.printData.printerName}</div><br />
            <div className="text-left">Printer Port: {props.printData.printerPort} </div>
          </div>
          <div className={cn(styles.imgSpin, 'od-spinner position-absolute')} />
        </div>
      </Modal>
      <Modal
        isOpen={props.openMovePopUp}
        loading={props.loading}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-0 text-right">
            <i
              role="presentation"
              onClick={() => { setOpenMovePopUp(); }}
              className="fa fa-times fs-24"
              aria-hidden="true"
            />
          </div>
          {clearId && (
            <div className="col-12 fs-18 mt-10 fw-700 text-center">
              <div>{CUSTOM_MESSAGES().CLEAR_SEAT}</div>
            </div>
          )}
          <div className="d-flex my-3 fs-12">
            <div className="px-1">
              <div role="presentation" onClick={() => { clearMoveArray(); }} className={cn(moveArray.some((d) => d === -1) ? 'btn-primary btn-ripple od-btn-primary' : 'btn-secondary btn-ripple  od-btn-secondary', 'rounded color-white px-3 py-1 text-center fs-16 ')}>{LABEL().TABLE}</div>
            </div>
            <div className={styles.wrapper} style={{gap: '10px'}}>
              {props?.seat?.seats && props.seat.seats.length > 0 && sort(props.seat.seats, 'number').map((item) => {
                return (
                  <>
                    {item.open && item.number !== (clearId?.number) && (
                    <div key={item.number} className="w-100">
                      <div role="presentation" onClick={() => setSelectedToMove(item.number)} className={cn(styles.btnBorderWhite, moveArray.length > 0 && moveArray.includes(item.number) ? 'btn-primary btn-ripple od-btn-primary' : 'btn-secondary od-btn-secondary', 'rounded text-center fs-16 py-1 px-2 color-white')}>{item.number}</div>
                    </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-ripple btn-secondary btn-lg od-btn-secondary" onClick={() => setOpenMovePopUp()}>
              <div className="fs-18">{LABEL().CANCEL}</div>
            </button>
            {printState ? (
              <button type="submit" disabled={moveArray.length === 0} className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { props.print(moveArray); setPrintState(false); setOpenMovePopUp(); }}>
                <div className="fs-18">{LABEL().PRINT}</div>
              </button>
            ) : (
              <button type="submit" disabled={moveArray.length === 0} className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { moveClick(moveData, moveArray, moveType); setOpenMovePopUp(); }}>
                <div className="fs-18">{LABEL().MOVE}</div>
              </button>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isConfirmationPopUp.isOpen || deletAll || sendAll || singleDelete || singleMove || sendSelected || deleteSelected}
        loading={props.loading}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-0 text-right">
            <i className="fa fa-times fs-24" aria-hidden="true" role="presentation" onClick={() => { setDeleteAllPopUp(); }} />
          </div>
          <div className="col-12 fs-18 fw-600 text-center">
            {deletAll && props.cart.length === 1 && CUSTOM_MESSAGES().SINGLE_DELETE_MSG }
            {sendAll && props.cart.length === 1 && CUSTOM_MESSAGES().SINGLE_SEND_MSG}
            {deletAll && props.cart.length > 1 && CUSTOM_MESSAGES().DELETE_ALL_UNSENT_MSG }
            {sendAll && props.cart.length > 1 && CUSTOM_MESSAGES().SEND_ALL_UNSENT_MSG}
            {singleDelete && CUSTOM_MESSAGES().SINGLE_DELETE_MSG}
            {singleMove && CUSTOM_MESSAGES().SINGLE_SEND_MSG}
            {sendSelected && moveSingle.length > 1 && CUSTOM_MESSAGES().MULTIPLE_SEND_MSG}
            {deleteSelected && singleItem.length > 1 && CUSTOM_MESSAGES().MULTIPLE_DELETE_MSG}
            {sendSelected && moveSingle.length === 1 && CUSTOM_MESSAGES().SINGLE_SELECTED_SEND_MSG}
            {deleteSelected && singleItem.length === 1 && CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG}
            {isConfirmationPopUp.type === 'unsentRepeat' && isConfirmationPopUp.data.length === 1 && CUSTOM_MESSAGES().REPEAT_ITEM}
            {isConfirmationPopUp.type === 'unsentRepeat' && isConfirmationPopUp.data.length > 1 && CUSTOM_MESSAGES().REPEAT_ITEMS}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setDeleteAllPopUp()}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            {deletAll && (
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { props.deleteAll(); setDeleteAllPopUp(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            )}
            {sendAll && (
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { props.sendAllItems(); setDeleteAllPopUp(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            )}
            {(singleMove || sendSelected) && (
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { props.sendSingle(moveSingle, 'sendSelect'); setDeleteAllPopUp(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            )}
            {(singleDelete || deleteSelected) && (
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { props.deleteItem(singleItem); setDeleteAllPopUp(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            )}
            {isConfirmationPopUp.type === 'unsentRepeat' && (
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  props.handleRepeatData(isConfirmationPopUp.data, 'unsent');
                  setIsConfirmationPopUp({ isOpen: false });
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            )}
          </div>
        </div>
      </Modal>
      {isVoidOpen && (
        <Modal
          isOpen={isVoidOpen}
          isModalCenter
          loading={props.loading}
        >
          <div className="m-2 justify-content-center align-items-center text-center">
            <div className="col-12 d-flex p-0">
              <div className="col-12 fs-18 fw-600 text-center">
                {CUSTOM_MESSAGES().SENT_VOID}
              </div>
              <div className="col-12 fs-24 text-right p-0" role="presentation" onClick={() => { setIsVoidOpen(false); }}>
                <i className="fa fa-times" aria-hidden="true" />
              </div>
            </div>
            <div className="col-12 d-flex mt-2 justify-content-center align-items-center text-center">
              <button className="col-4 m-2 btn btn-secondary od-btn-secondary" type="button" onClick={() => { setIsVoidOpen(false); }}>
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button className="col-4 m-2 btn btn-primary btn-ripple od-btn-primary" type="button" onClick={() => { setIsVoidOpen(false); props.handleVoidItems(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        isOpen={isRepeatModalOpen}
        loading={props.loading}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-2 text-right">
            <i
              role="presentation"
              onClick={() => { setIsRepeatModalOpen(!isRepeatModalOpen); }}
              className="fa fa-times fs-24"
              aria-hidden="true"
            />
          </div>
          <div className="d-flex my-3 fs-12">
            <div className="px-1">
              <div role="presentation" onClick={() => { clearMoveArray(); }} className={cn(moveArray.some((d) => d === -1) ? 'btn-primary od-btn-primary' : 'btn-secondary od-btn-secondary', 'rounded color-white px-3 py-1 text-center fs-16 ')}>{LABEL().TABLE}</div>
            </div>
            <div className={styles.wrapper}>
              {props?.seat?.seats && props?.seat?.seats.length > 0 && sort(props.seat.seats, 'number').map((item, index) => {
                return item.open && (
                  <div key={item.number} className="w-100">
                    <div role="presentation" onClick={() => setSelectedToMove(item.number)} className={cn(styles.btnBorderWhite, index !== 0 && 'px-2', moveArray.length > 0 && moveArray.includes(item.number) ? 'btn-primary od-btn-primary' : 'btn-secondary od-btn-secondary', 'rounded text-center fs-16 py-1 px-2 color-white')}>{item.number}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary btn-lg od-btn-secondary" onClick={() => { setMoveArray([]); setIsRepeatModalOpen(!isRepeatModalOpen); }}>
              <div className="fs-18">{LABEL().CANCEL}</div>
            </button>
            <button type="submit" disabled={moveArray.length === 0} className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { setMoveArray([]); props.handleRepeatData(repeatData, moveArray, repeatType); setIsRepeatModalOpen(!isRepeatModalOpen); }}>
              <div className="fs-18">{LABEL().REPEAT}</div>
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openPriceModal.modal}
        loading={props.loading}
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
            <div className="fs-24" role="presentation" onClick={() => { setOpenPriceModal({ ...openPriceModal, modal: false }); }}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <Formik
            initialValues={{ price: (openPriceModal.val.price) }}
            onSubmit={submitPrice}
            validate={validatePrice}
            enableReinitialize
          >
            {() => {
              return (
                <Form>
                  {openPriceModal.modal && (
                    <KeyboardInput
                      name="price"
                      type="number"
                      value={`${openPriceModal.val.price}`}
                      erase
                      isDecimal
                      placeholder="Enter Price"
                      isOpen={openPriceModal.modal}
                      customClass="mt-2"
                    />
                  )}
                  <button
                    className={cn('w-100 mt-2 btn btn-primary btn-ripple od-btn-primary')}
                    type="submit"
                    style={{ height: '10vh' }}
                  >
                    <div className="fs-18">{LABEL().UPDATE_CART}</div>
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal>
      {isKiosk && kioskModal?.isCart && (
        <Modal
          isOpen={kioskModal?.isCart}
          isModalCenter
          loading={props.loading}
          customClass2={styles.maxWidth}
        >
          <div className="m-0 h-100 justify-content-center align-items-center text-center position-relative">
            <div className="h-80">
              <KioskCart />
            </div>
            <div className="h-20 my-2">
              <div className="col-12 d-flex my-2">
                <div className="col-12 text-center">
                  <button className={cn('btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20')} type="button" onClick={() => { setKioskModal({ ...kioskModal, isCart: !kioskModal.isCart }); }}>
                    <div className="fs-30">{LABEL().KIOSK_CLOSE}</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        isOpen={isDiscountPopUp}
        isModalCenter
      >
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className={cn('px-2 text-right')}>
            <i
              role="presentation"
              className={cn('fa fa-times fs-24')}
              onClick={() => setIsDiscountPopup(!isDiscountPopUp)}
            />
          </div>
          {props.discounts && Object.values(props.discounts).length > 0 ? (
            <div className="fs-24 fw-600 text-center px-0 py-2 h50vh overflowY overflowXHidden">
              {Object?.values(props.discounts)?.map((item) => {
                return (
                  <div role="presentation" key={item.id} className={cn(selected.includes(item.id) ? 'bgGreen' : '', 'card my-2 py-2 col-12 text-center')} onClick={() => handleSelection(item)}>
                    {item.name}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="fs-24 fw-600 text-center px-0 py-2 h-100 overflowY overflowXHidden">
              {CUSTOM_MESSAGES().NO_DISCOUNTS}
            </div>
          )}
          <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
            <div className="col-12 px-1">
              <button disabled={!selected} className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { setIsDiscountPopup(!isDiscountPopUp); handleApplyDiscount(); }}>
                <div className="fs-30">{LABEL().APPLY}</div>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {isOpenPopUp && (
        <Modal
          isOpen={isOpenPopUp}
          isModalCenter
        >
          <div className="p-2 justify-content-center align-items-center text-center">
            <div className={cn('px-2 text-right')}>
              <i
                role="presentation"
                className={cn('fa fa-times fs-24')}
                onClick={() => setIsOpenPopUp(!isOpenPopUp)}
              />
            </div>
            <OpenPopUp isOpen={isOpenPopUp} discounts={props.discounts} validate={validate} onSubmit={handleApplyDiscount} selected={selected} isOpenPopUp={isOpenPopUp} setIsOpenPopUp={setIsOpenPopUp} />
          </div>
        </Modal>
      )}
    </>
  );
};

export default Orders;
